/* global $ */
const SELECTORS = {
  wrapperModalWindow: ".views_exposed_form--form--wrapper",
  // filterButton: ".views_exposed_form--filter--button",
  filterOption: ".views_exposed_form--form--filter--fieldgroup",
  filterOptionCheckbox: ".views_exposed_form--form--checkbox",
  filterOptionSearch: ".views_exposed_form--form--filter-options-search",
  // filterFormClose: ".views_exposed_form--close",
  // filterFormKeyClose: ".views_exposed_form--close",
  eyebrowFocus: ".views_exposed_form--eyebrow--close--button",
  eyebrowFocusOut: ".views_exposed_form--eyebrow--close--button",
  eyebrowRemove: ".views_exposed_form--eyebrow--close--button",
  eyebrowRemoveByKey: ".views_exposed_form--eyebrow--close--button",
  formSubmit: ".views_exposed_form--form--submit input:first-child",
};

class ModalViewFilter {
  constructor(context) {
    this.context = context;
  }

  init() {
    this.wrapperModalWindow = this.context.querySelector(
      SELECTORS.wrapperModalWindow,
    );
    // this.filterButton = this.context.querySelector(SELECTORS.filterButton);
    // this.filterFormClose = this.context.querySelector(
    //   SELECTORS.filterFormClose
    // );
    // this.filterFormKeyClose = this.context.querySelector(
    //   SELECTORS.filterFormKeyClose
    // );
    this.formSubmit = this.context.querySelector(SELECTORS.formSubmit);
    this.eyebrowFocus = this.context.querySelectorAll(SELECTORS.eyebrowFocus);
    this.eyebrowFocusOut = this.context.querySelectorAll(
      SELECTORS.eyebrowFocusOut,
    );
    this.eyebrowRemove = this.context.querySelectorAll(SELECTORS.eyebrowRemove);
    this.eyebrowRemoveByKey = this.context.querySelectorAll(
      SELECTORS.eyebrowRemoveByKey,
    );
    this.filterOption = this.context.querySelectorAll(SELECTORS.filterOption);
    this.filterOptionCheckbox = this.context.querySelectorAll(
      SELECTORS.filterOptionCheckbox,
    );
    this.filterOptionSearch = this.context.querySelectorAll(
      SELECTORS.filterOptionSearch,
    );

    this.subscribe();
  }

  subscribe() {
    $(document).ready(function () {
      $(".views_exposed_form--filter--button").attr("tabindex", "0");
    });

    this.wrapperModalWindow.addEventListener("click", function (e) {
      if (e.target.classList.contains("views_exposed_form--form--wrapper")) {
        $(".views_exposed_form--form--wrapper").css("display", "none");
        $("body").css("overflow-y", "auto");
      }
    });

    // this.filterButton.addEventListener("click", () => {
    //   $(".views_exposed_form--form--wrapper").css("display", "block");
    //   $("body").css("overflow-y", "hidden");
    // });

    this.formSubmit.addEventListener("click", () => {
      $(".views_exposed_form--form--wrapper").css("display", "none");
      $("body").css("overflow-y", "auto");
    });

    // Event listner for checking if the click is outside the dropdown box
    document.addEventListener(
      "click",
      function (event) {
        this.filterOption.forEach((details) => {
          if (!details.contains(event.target) && details.hasAttribute("open")) {
            details.removeAttribute("open");
          }
        });
      }.bind(this),
    );

    // this.filterFormClose.addEventListener("click", () => {
    //   $(".views_exposed_form--form--wrapper").css("display", "none");
    //   $("body").css("overflow-y", "auto");
    // });

    // this.filterFormKeyClose.addEventListener("keydown", (e) => {
    //   if (e.code === "Space") {
    //     e.preventDefault();
    //     $(".views_exposed_form--form--wrapper").css("display", "none");
    //   }
    // });

    this.eyebrowFocus.forEach((item) => {
      item.addEventListener("focus", (e) => {
        $(e.target.parentElement).css(
          "box-shadow",
          "inset 0px 0px 0px 1px white",
        );
      });
    });

    this.eyebrowFocusOut.forEach((item) => {
      item.addEventListener("focusout", (e) => {
        $(e.target.parentElement).css("box-shadow", "none");
      });
    });

    this.eyebrowRemove.forEach((item) => {
      item.addEventListener("click", (e) => {
        $(e.target.parentElement).css("box-shadow", "none");
        document
          .getElementById(e.target.getAttribute("for"))
          .removeAttribute("checked");
        $(".views_exposed_form--form--submit input:first-child").click();
      });
    });

    this.filterOptionCheckbox.forEach((item) => {
      item.addEventListener("change", () => {
        $(".views_exposed_form--form--submit input:first-child").click();
      });
    });

    this.eyebrowRemoveByKey.forEach((item) => {
      item.addEventListener("keydown", (e) => {
        if (e.code === "Space") {
          $(e.target.parentElement.parentElement).css("box-shadow", "none");
          e.preventDefault();
          document
            .getElementById(e.target.getAttribute("for"))
            .removeAttribute("checked");
          $(".views_exposed_form--form--submit input:first-child").click();
        }
        $(e.target.parentElement).css(
          "box-shadow",
          "inset 0px 0px 0px 1px white",
        );
      });
    });

    // Add a click event listener to each details element
    this.filterOption.forEach((details) => {
      details.addEventListener("click", () => {
        // Close all other details elements
        this.filterOption.forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.removeAttribute("open");
          }
        });
      });
    });

    this.filterOptionSearch.forEach((inputSearch) => {
      inputSearch.addEventListener("input", () => {
        const searchTerm = inputSearch.value.toLowerCase();
        const closestDetails = inputSearch.closest("details");

        if (!closestDetails) {
          return; // No parent details element found
        }

        const filterOptions = closestDetails.querySelectorAll(
          ".views_exposed_form--form--filter-option",
        );

        // Loop through filter options and hide/show based on the search term
        filterOptions.forEach((option) => {
          const label = option.querySelector(
            ".views_exposed_form--form--checkbox--label",
          );
          if (searchTerm.length >= 0) {
            if (label.textContent.toLowerCase().includes(searchTerm)) {
              option.style.display = "block";
            } else {
              option.style.display = "none";
            }
          } else {
            option.style.display = "block";
          }
        });
      });
    });
  }
}

export default ModalViewFilter;
